import PropTypes from 'prop-types';
import Presenter from 'utils/PropTypesPresenter';

export default new Presenter(
  {
    id: PropTypes.number,
    waitingTime: PropTypes.number,
    order: PropTypes.number,
    message: PropTypes.string,
  },
  {},
);



// WEBPACK FOOTER //
// ./src/presenters/AutoFollowupsMessagePresenter.js